import { useEffect } from 'react';
import './UI.css';

export function PageHeader({ titulo, subtitulo, children }) {
  return (
    <div className="ph">
      <div className="ph-text">
        <h1 className="ph-titulo">{titulo}</h1>
        {subtitulo && <p className="ph-sub">{subtitulo}</p>}
      </div>
      {children && <div className="ph-actions">{children}</div>}
    </div>
  );
}

export function SearchBar({ value, onChange, placeholder }) {
  return (
    <div className="search">
      <span className="search-ic">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
      </span>
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder || 'Buscar...'}
      />
      {value && <button className="search-clr" onClick={() => onChange('')}>✕</button>}
    </div>
  );
}

export function Table({ colunas, dados, onRowClick, vazio = 'Nenhum registro encontrado.' }) {
  if (!dados?.length) return <div className="tbl-vazio">{vazio}</div>;
  return (
    <div className="tbl-wrap">
      <table className="tbl">
        <thead>
          <tr>{colunas.map(c => <th key={c.key} style={{ width: c.width }}>{c.label}</th>)}</tr>
        </thead>
        <tbody>
          {dados.map((row, i) => (
            <tr
              key={i}
              onClick={() => onRowClick?.(row)}
              className={onRowClick ? 'tbl-row--click' : ''}
            >
              {colunas.map(c => (
                <td key={c.key} data-label={c.label}>
                  {c.render ? c.render(row[c.key], row) : (row[c.key] ?? '—')}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function Loading({ texto = 'Carregando...' }) {
  return (
    <div className="loading">
      <div className="loading-spin" />
      <span>{texto}</span>
    </div>
  );
}

export function Erro({ mensagem, onRetry }) {
  return (
    <div className="erro">
      <span>⚠ {mensagem}</span>
      {onRetry && <button className="erro-btn" onClick={onRetry}>Tentar novamente</button>}
    </div>
  );
}

export function Badge({ valor, tipo = 'default' }) {
  return <span className={`badge badge--${tipo}`}>{valor}</span>;
}

export function StatCard({ label, valor, sub, cor = 'laranja', icone }) {
  return (
    <div className={`stat stat--${cor}`}>
      {icone && <div className="stat-ico">{icone}</div>}
      <div className="stat-label">{label}</div>
      <div className="stat-valor">{valor}</div>
      {sub && <div className="stat-sub">{sub}</div>}
    </div>
  );
}

export function Modal({ titulo, onClose, children }) {
  useEffect(() => {
    const fn = e => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', fn);
    return () => document.removeEventListener('keydown', fn);
  }, [onClose]);
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-titulo">{titulo}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}

export function Paginacao({ offset, limite, total, onChange }) {
  return (
    <div className="pag">
      <button disabled={offset === 0} onClick={() => onChange(Math.max(0, offset - limite))}>
        ← Anterior
      </button>
      <span>Página {Math.floor(offset / limite) + 1}</span>
      <button disabled={total < limite} onClick={() => onChange(offset + limite)}>
        Próxima →
      </button>
    </div>
  );
}
